module.exports = __webpack_public_path__ + "static/media/AB_L31_6.64af7a66.jpg";